import { VinculoPontoUnidade } from '@/views/RegistroPontoNovo/types-registro-ponto';

export default class ReconhecimentoFacialUtils {
  public static tratarVinculosParaRecFacial(vinculos: VinculoPontoUnidade[]) {
    if(!vinculos || !vinculos.length) {
      return false; // mensagem de erro
    }

    const vinculosRecFacial = vinculos.flatMap((vinculo) => {
      return vinculo.HASHFACIAIS.map((hash) => {
        const hashFloat = hash.split(',').map((n: string) => parseFloat(n));
        return [hashFloat, vinculo.NRVINCULOM];
      });
    });

    const vinculosHashes = JSON.stringify(vinculosRecFacial);

    return vinculosHashes;
  }
}
